import React, { useCallback, useContext, useMemo } from 'react';
import classnames from 'classnames';
import { getBrowserCookies, cookieExpiresInDays } from 'src/util/cookies';
import { COOKIE_NAME as CONTENT_CURRENCY_COOKIE } from 'src/core/state/currency';

import { ConfigContext } from '../AppShell/ConfigProvider';

import classes from './Controls.scss';
import { HeaderStoreDropdown } from './Dropdown';

/**
 * Currency selector
 */
export const CurrencySelect = React.memo(({ whiteIcons }: { whiteIcons: boolean }) => {
    /**
     * Bring in state from global context
     */
    const { currentCurrency, availableCurrencies } = useContext(ConfigContext);
    /**
     * Handler for selecting a currency
     */
    const selectCurrency = useCallback((code) => {
        // Write cookie and reload only. Calling setCurrency first triggers useCurrencyChange
        // refetches that can fail and flash the Oops page before reload completes.
        getBrowserCookies().set(CONTENT_CURRENCY_COOKIE, code, cookieExpiresInDays(3));
        window.location.reload();
    }, []);

    /**
     * Filter the available currencies to NOT
     * include the currently selected one.
     */
    const filtered = useMemo(() => {
        return availableCurrencies.filter((x) => x?.code && x.code !== currentCurrency.code);
    }, [availableCurrencies, currentCurrency.code]);

    return (
        <HeaderStoreDropdown
            data-test-id="CurrencySelect"
            text={currentCurrency.code || '...'}
            items={filtered}
            whiteIcons={whiteIcons}
            render={({ item, close }) => {
                return (
                    <button
                        type="button"
                        className={classnames(classes.controlListButton, { [classes.whiteIcons]: whiteIcons })}
                        onClick={() => {
                            selectCurrency(item.code);
                            close();
                        }}
                    >
                        {item.code}
                    </button>
                );
            }}
        />
    );
});
